var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1084px",
    height: "268px",
    viewBox: "0 0 1084 268",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "discover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.0000013%",
    cy: "50%",
    fx: "50.0000013%",
    fy: "50%",
    r: "50%",
    gradientTransform: "translate(0.500000,0.500000),scale(1.000000,0.999761),translate(-0.500000,-0.500000)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8330",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "discover",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Disc",
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: 13,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 9.8425188,
    y: 27.69292
  }, "Disc")), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(523.405523, 88.146493)",
    fill: "url(#radialGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.959313,73.9973101 C147.965301,100.432006 133.866168,124.861235 110.974323,138.080312 C88.0824789,151.29939 59.8768342,151.29939 36.9849896,138.080312 C14.093145,124.861235 -0.00598750071,100.432006 6.7464012e-15,73.9973101 C-0.00598750071,47.5626143 14.093145,23.1333852 36.9849896,9.91430792 C59.8768342,-3.30476931 88.0824789,-3.30476931 110.974323,9.91430792 C133.866168,23.1333852 147.965301,47.5626143 147.959313,73.9973101 Z",
    id: "path3194"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Disc",
    fill: "#000000",
    fontFamily: "Verdana-Bold, Verdana",
    fontSize: 220,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 221
  }, "Disc")), /*#__PURE__*/React.createElement("text", {
    id: "tspan2913",
    fill: "#000000",
    fontFamily: "Verdana-Bold, Verdana",
    fontSize: 220,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 665.354239,
    y: 221.10743
  }, "ver")), /*#__PURE__*/React.createElement("text", {
    id: "tspan2822",
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: 40,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1053.14952,
    y: 96.984271
  }, "\xAE"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.1f830dfa5074267541ad031b251bbf5e.svg";
export { ForwardRef as ReactComponent };